import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { ScrollToTop } from "../components";
import { connect } from "react-redux";
import DefaultLayout from "../layout/default";
import BlankLayout from "../layout/fullpage";
import Loading from "../components/Loader/Loading";

// Auth pages
import AuthLogin1 from "../pages/auths/AuthLogin1";

// Assets
import AssetList from "../pages/Asset/AssetList";
import AssetDetail from "../pages/Asset/AssetDetails";
import MyAsset from "../pages/Myasset";
import OwnAsset from "../pages/Myasset/OwnAsset";
import DepartmentAsset from "../pages/Myasset/DepartmentAsset";

//grn
import GrnAdd from "../pages/Grn/GrnAdd";
import GrnDetailsPage from "../pages/Grn/GrnDetails";
import GRNListPage from "../pages/Grn/GrnList";

// Error pages
import NotFound from "../pages/error/NotFound";
import PermissionDenied from "../pages/error/PermissionDenied";
import Dashboard from "../pages/Dashboard";

// Master pages
import CategoryManagement from "../pages/Master/CategoryManagement";
import SubcategoryManagement from "../pages/Master/SubcategoryManagement";
import LocationSettings from "../pages/Master/LocationSettings";
import DepartmentSettings from "../pages/Master/DepartmentSettings";
import DesignationSettings from "../pages/Master/DesignationSettings";
import AreaSettings from "../pages/Master/AreaSettings";

// Analytics and Report pages
import Analytics from "../pages/analytics";
import ReportPage from "../pages/report";

import UserList from "../pages/User/UserList";
import VendorListPage from "../pages/Vendor/VendorList";

// import AssetTableView from "../pages/Asset/AssetTableView";
// import AssetGridView from "../pages/Asset/AssetGridView";

// import AssetDetails from "../pages/Asset/AssetDetail";
// import AssetOverview from "../pages/Asset/AssetDetail/AssetOverview";
// import AssetMaintenance from "../pages/Asset/AssetDetail/AssetMaintenance";
// import AssetDisposal from "../pages/Asset/AssetDetail/AssetDisposal";
// import AssetInsurance from "../pages/Asset/AssetDetail/AssetInsurance";
// import AssetUnitList from "../pages/Asset/AssetDetail/AssetUnitList";

import UserDetails from "../pages/User/UserDetails";
import VendorAssetUnits from "../pages/Vendor/VendorAssetUnits";
import VendorAssetsSummary from "../pages/Vendor/VendorAssetsSummary";
//permission
import {
  OnlyStoreManager,
  FullAccessRoles,
  ExcepEmployeeHOD,
  OnlyAdmin,
  ExcepEmployee,
  AdminAuditor,
  AdminAuditorLocation,
  ExcepEmployeeAdmin,
  OnlyLocationManager,
  OnlyEmployee,
} from "./permission";
import AssetReturnRequest from "../pages/AssetReturnRequest";
import DepartmentEmployeeAsset from "../pages/Myasset/DepartmentEmployeeAsset";
import AssetMoveRequest from "../pages/AssetMoveRequest";
import AssetTransferRequest from "../pages/AssetTransferRequest";

//auditsessionlist
import AuditSession from "../pages/AuditSession";
import SessiondDetails from "../pages/AuditSession/SessionDetails";

//audit asset scan
import Audit from "../pages/Audit";
import EmployeeAssetDetails from "../pages/Myasset/EmployeeAssetDetails";
import StoreAssetTransferrequest from "../pages/StoeAssetTranferRequest";
import AuditSessionAdd from "../pages/AuditSession/AddSession";
import AreaAuditScanDetails from "../pages/AuditSession/AreaAuditScanDetails";

//faq
import Faq from "../pages/Faq";
import FaqAdd from "../pages/Faq/FaqAdd";
import FinalAuditReport from "../pages/AuditSession/FinalAuditReport";
import SystemLog from "../pages/SystemLog";

import RfidReaderDetails from "../pages/RFIDReaderDetails/RfidReaderDetails";
import AssetAdd from "../pages/Grn/GrnDetails/AssetAdd";

const FlashScreen = () => {
  return (
    <BlankLayout title="Loading..." mask="2" centered>
      <Loading />
    </BlankLayout>
  );
};

export const allRoutes = [
  {
    url: "/",
    element: <AuthLogin1 />,
    isProtected: false,
    routeTitle: "Login",
    accessRole: [],
  },

  {
    url: "/audit",
    element: <Audit />,
    isProtected: false,
    routeTitle: "audit",
    accessRole: [],
  },

  {
    url: "/dashboard",
    element: <Dashboard />,
    isProtected: true,
    routeTitle: "dashboard",
    accessRole: FullAccessRoles,
  },

  //asset
  {
    url: "/assets/:type",
    element: <AssetList />,
    isProtected: true,
    routeTitle: "Asset List",
    accessRole: ExcepEmployeeHOD,
  },
  {
    url: "/asset/:id/:type",
    element: <AssetDetail />,
    isProtected: true,
    routeTitle: "Asset details",
    accessRole: ExcepEmployeeHOD,
  },
  {
    url: "return-request",
    element: <AssetReturnRequest />,
    isProtected: true,
    routeTitle: "Asset Return Request",
    accessRole: OnlyStoreManager,
  },
  {
    url: "move-request",
    element: <AssetMoveRequest />,
    isProtected: true,
    routeTitle: "Asset Move Request",
    accessRole: OnlyLocationManager,
  },
  {
    url: "/transfer-request",
    element: <AssetTransferRequest />,
    isProtected: true,
    routeTitle: "Asset Transfer Request",
    accessRole: OnlyEmployee,
  },
  //grn
  {
    url: "/grn",
    element: <GRNListPage />,
    isProtected: true,
    routeTitle: "GRN list",
    accessRole: ExcepEmployeeHOD,
  },
  {
    url: "/grn-add",
    element: <GrnAdd />,
    isProtected: true,
    routeTitle: "GRN Add",
    accessRole: OnlyStoreManager,
  },
  {
    url: "/grn/:id",
    element: <GrnDetailsPage />,
    isProtected: true,
    routeTitle: "GRN Details",
    accessRole: ExcepEmployeeHOD,
  },
   {
    url: "/add-asset/:id",
    element:<AssetAdd/>,
    isProtected: true,
    routeTitle: "Asset add",
    accessRole:OnlyStoreManager,
  },

  //my asset
  {
    url: "/my-asset",
    element: <MyAsset />,
    isProtected: true,
    routeTitle: "my-asset",
    accessRole: FullAccessRoles,
    children: [
      {
        url: "",
        element: <OwnAsset />,
        routeTitle: "my-asset",
        accessRole: FullAccessRoles,
      },
      {
        url: "department-asset",
        element: <DepartmentAsset />,
        routeTitle: "department-asset",
        accessRole: ExcepEmployeeAdmin,
      },
      {
        url: "departmentEmp-asset",
        element: <DepartmentEmployeeAsset />,
        routeTitle: "DepartmentEmp-asset",
        accessRole: ExcepEmployeeAdmin,
      },
      {
        url: "employee-asset-deatails/:id",
        element: <EmployeeAssetDetails />,
        routeTitle: "Employee-asset-details",
        accessRole: ExcepEmployeeAdmin,
      },
    ],
  },
  {
    url: "/users/:userId",
    element: <UserDetails />,
    isProtected: true,
    routeTitle: "User Details",
    accessRole: ExcepEmployee,
  },
  {
    url: "/users",
    element: <UserList />,
    isProtected: true,
    routeTitle: "Users",
    accessRole: ExcepEmployee,
  },
  {
    url: "/vendors",
    element: <VendorListPage />,
    isProtected: true,
    routeTitle: "Users",
    accessRole: ExcepEmployeeHOD,
  },
  {
    url: "/vendor/:vendorId",
    element: <VendorAssetsSummary />,
    isProtected: true,
    routeTitle: "Vendor Assets Summary",
    accessRole: ExcepEmployeeHOD,
  },
  {
    url: "/vendor/:vendorId",
    element: <VendorAssetUnits />,
    isProtected: true,
    routeTitle: "Vendor Asset Units",
    accessRole: ExcepEmployeeHOD,
  },
  // master urls
  {
    url: "/catagory",
    element: <CategoryManagement />,
    isProtected: true,
    routeTitle: "Catagory",
    accessRole: AdminAuditor,
  },
  {
    url: "/subcategory",
    element: <SubcategoryManagement />,
    isProtected: true,
    routeTitle: "Subcategory",
    accessRole: AdminAuditor,
  },

  {
    url: "/locations",
    element: <LocationSettings />,
    isProtected: true,
    routeTitle: "Locations",
    accessRole: AdminAuditor,
  },
  {
    url: "/departments",
    element: <DepartmentSettings />,
    isProtected: true,
    routeTitle: "Departments",
    accessRole: AdminAuditorLocation,
  },
  {
    url: "/areas",
    element: <AreaSettings />,
    isProtected: true,
    routeTitle: "Areas",
    accessRole: AdminAuditorLocation,
  },
  {
    url: "/designations",
    element: <DesignationSettings />,
    isProtected: true,
    routeTitle: "Designations",
    accessRole: OnlyAdmin,
  },
  {
    url: "/analytics",
    element: <Analytics />,
    isProtected: true,
    routeTitle: "Analytics",
    accessRole: AdminAuditor,
  },
  {
    url: "/report",
    element: <ReportPage />,
    isProtected: true,
    routeTitle: "Reports",
    accessRole: AdminAuditor,
  },

  //session
  {
    url: "/auditsession",
    element: <AuditSession />,
    isProtected: true,
    routeTitle: "Audit",
    accessRole: FullAccessRoles,
  },
  {
    url: "/audit-session/:id",
    element: <SessiondDetails />,
    isProtected: true,
    routeTitle: "Session-Details",
    accessRole: FullAccessRoles,
  },
  {
    url: "/session-add",
    element: <AuditSessionAdd />,
    isProtected: true,
    routeTitle: "Session-add",
    accessRole: OnlyAdmin,
  },
  {
    url: "/area-audit/:sessionId/:areaId",
    element: <AreaAuditScanDetails />,
    isProtected: true,
    routeTitle: "area-audit",
    accessRole: FullAccessRoles,
  },
  {
    url: "/final-audit/:sessionId",
    element: <FinalAuditReport />,
    isProtected: true,
    routeTitle: "final-audit",
    accessRole: FullAccessRoles,
  },

  //log
  {
    url: "/system-log",
    element: <SystemLog />,
    isProtected: true,
    routeTitle: "system-log",
    accessRole: OnlyAdmin,
  },
  //faq
  {
    url: "/faq",
    element: <Faq />,
    isProtected: true,
    routeTitle: "Faq",
    accessRole: FullAccessRoles,
  },
  {
    url: "/faq-add",
    element: <FaqAdd />,
    isProtected: true,
    routeTitle: "Faq-Add",
    accessRole: OnlyAdmin,
  },
  {
    url: "/faq-edit/:id",
    element: <FaqAdd />,
    isProtected: true,
    routeTitle: "Faq-Edit",
    accessRole: OnlyAdmin,
  },

  //Asset Transfer part

  {
    url: "/store-asset-request",
    element: <StoreAssetTransferrequest />,
    isProtected: true,
    routeTitle: "asset-transfer",
    accessRole: OnlyStoreManager,
  },
  {
    url: "/rfid-reader-details",
    element: <RfidReaderDetails />,
    isProtected: true,
    routeTitle: "rfid-reader-details",
    accessRole: FullAccessRoles,
  }
];
function Router({ isAuthenticated, userRole, isCheckingAuth }) {
  const handleProtectedRoute = (route) => {
    if (!isAuthenticated) {
      return <Navigate to="/" />;
    }
    if (!route.accessRole.includes(userRole)) {
      return <PermissionDenied />;
    }
    return route.element;
  };

  const handlePublicRoute = (route) => {
    if (isAuthenticated) {
      // Redirect authenticated users trying to access public routes
      return <Navigate to="/dashboard" />;
    }
    return route.element;
  };

  const renderRoutes = (routes, isChildElement = false) =>
    routes.map((item) => {
      let element;

      if (isChildElement) {
        element = item.element;
      } else {
        // Top-level route with layout
        element = item.isProtected ? (
          <DefaultLayout title={item.routeTitle}>
            {handleProtectedRoute(item)}
          </DefaultLayout>
        ) : (
          <BlankLayout title={item.routeTitle} centered>
            {handlePublicRoute(item)}
          </BlankLayout>
        );
      }

      return (
        <Route key={item.url} path={item.url} element={element}>
          {item.children &&
            renderRoutes(
              item.children.map((child) => ({
                ...child,
                isProtected: item.isProtected,
                accessRole: item.accessRole,
              })),
              true // pass Child Element flag
            )}
        </Route>
      );
    });

  return isCheckingAuth ? (
    <FlashScreen />
  ) : (
    <ScrollToTop>
      <Routes>
        {renderRoutes(allRoutes)}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ScrollToTop>
  );
}

const mapStateToProps = (state) => ({
  userRole: state.auth.user?.role || "",
  isAuthenticated: state.auth.user !== null,
  isCheckingAuth: state.auth.isCheckingAuth,
});

export default connect(mapStateToProps)(Router);
